import React from "react";
import Homepage_Data from "../../../utils/HomepageData";
import LineProgressBar from "../../../components/LineProgressBar";
import { openInNewTab } from "../../../utils/util";
import { pushToDataLayer } from "../../../utils/gtm";

export default function ExpertInsights() {
  const { expertInsights } = Homepage_Data;

  return (
    <div className="mt-[60px] mx-[20px] lg:mx-auto lg:max-w-10xl lg:px-8">
      {/* Heading */}
      <h2 className="text-[20px] text-[#2C2C2C] font-[700] lg:text-[40px] lg:text-center">
        Expert Insights
      </h2>

      {/* Description */}
      <p className="text-[14px] text-[#888888] font-[600] mt-[15px] lg:text-[20px] lg:text-center lg:max-w-[900px] lg:mx-auto lg:mt-[20px]">
        {expertInsights.heading}
      </p>

      {/* Cards Container */}
      <div className="flex overflow-x-auto no-scrollbar gap-[5px] mt-[20px] lg:overflow-x-auto lg:flex-nowrap lg:gap-[42px] lg:mt-[40px] lg:pb-4 2xl:px-[100px]">
        {expertInsights.cards.map((item, index) => (
          <div
            key={index}
            className="flex-shrink-0 flex flex-col justify-center py-[15px] sm:py-[30px] bg-[#FFFFFF] px-4 lg:px-8 shadow-lg rounded-lg border border-[#6C33B524] lg:w-[400px] lg:min-w-[300px]  lg:hover:shadow-xl transition-shadow duration-300"
          >
            <div className="w-[140px] lg:w-full">
              {/* Card Heading */}
              {/* <p className="text-[12px] font-[600] text-center mb-[10px] lg:text-[22px] lg:mb-[15px]">
                {item.cardHeading}
              </p> */}
              <div className="w-full flex justify-center items-center mb-5">
                <img
                  src={item.img}
                  alt="/company-logo"
                  className="w-24 h-10 md:w-40 md:h-20"
                />
              </div>
              {/* Progress Bars */}
              <LineProgressBar title={item.fees} value={item.slider1} />
              <LineProgressBar
                title={item.transferSpeed}
                value={item.slider2}
              />
              <LineProgressBar title={item.safety} value={item.slider3} />
              <LineProgressBar title={item.ease} value={item.slider4} />

              {/* Button */}
            </div>
            <button
              className="mt-[10px] bg-[#7B3BCC] text-white text-[10px] lg:text-[18px] lg:mt-[15px] lg:cursor-pointer lg:hover:scale(103) transition-colors duration-300 px-5 py-2 rounded-lg mx-auto"
              onClick={() => {
                pushToDataLayer("service_rating_viewed", {
                  provider_rating: item.cardHeading,
                });
                openInNewTab(item.href);
              }}
            >
              {item.btnText}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
